import {
    CHART_TYPE_DAYS_ON_MARKET,
    CHART_TYPE_HOME_PRICE,
    CHART_TYPE_INVENTORY,
    CHART_TYPE_NEW_LISTINGS,
    CHART_TYPE_PRICE_VS_INVENTORY,
} from './captions';

export const COLOR_TEAL = '#00555B';
export const COLOR_INK = '#000000';
export const COLOR_SOURCE = '#696969';
export const COLOR_GRID = 'rgba(26, 26, 26, 0.1)';
export const COLOR_DIVIDER = '#D5D5D5';

const IMAGE_ROOT = './images/HousingSnapshotShareable';

export const LOGO_PATH = './images/lr-logo-disclaimer-blue.png';
export const EQUAL_HOUSING_LOGO_PATH = `${IMAGE_ROOT}/equal-housing-logo.png`;

const skins = {
    [CHART_TYPE_DAYS_ON_MARKET]: {
        BACKGROUND_COLOR: '#FCFCFC',
        HEADER_BAND: { height: 220, color: '#D5F5F7' },
        TEXT_ALIGN: 'left',
        STAT: { fontSize: 30, lineHeight: 40 },
        HEADLINE: { fontSize: 30, lineHeight: 40 },
        SUBLINE: { fontSize: 24, lineHeight: 40 },
        ILLUSTRATION: {
            src: `${IMAGE_ROOT}/days-on-market.svg`,
            width: 261,
            height: 207,
            top: 19,
            right: 0,
            behindChart: false,
        },
        CHART: { top: 236, left: 30, width: 840, height: 303 },
        DIVIDER_TOP: 546,
    },
    [CHART_TYPE_INVENTORY]: {
        BACKGROUND_COLOR: '#F9F9F9',
        TEXT_ALIGN: 'center',
        STAT: { fontSize: 32, lineHeight: 42 },
        HEADLINE: { fontSize: 28, lineHeight: 42 },
        SUBLINE: { fontSize: 26, lineHeight: 42 },
        ILLUSTRATION: {
            src: `${IMAGE_ROOT}/active-listings.svg`,
            width: 401,
            height: 121,
            top: 373,
            left: 250,
            behindChart: true,
        },
        CHART: { top: 210, left: 30, width: 840, height: 320 },
        DIVIDER_TOP: 546,
    },
    [CHART_TYPE_NEW_LISTINGS]: {
        BACKGROUND_COLOR: '#F9F9F9',
        TEXT_ALIGN: 'left',
        HEADER_WIDTH: 620,
        STAT: { fontSize: 34, lineHeight: 48 },
        HEADLINE: { fontSize: 30, lineHeight: 42 },
        SUBLINE: { fontSize: 26, lineHeight: 42 },
        ILLUSTRATION: {
            src: `${IMAGE_ROOT}/new-listings.svg`,
            width: 193,
            height: 200,
            top: 46,
            left: 671,
            behindChart: false,
        },
        CHART: { top: 224, left: 30, width: 840, height: 300 },
        DIVIDER_TOP: 546,
    },
    [CHART_TYPE_HOME_PRICE]: {
        BACKGROUND_COLOR: '#FBFAF1',
        TEXT_ALIGN: 'left',
        HEADER_WIDTH: 640,
        STAT: { fontSize: 34, lineHeight: 48 },
        HEADLINE: { fontSize: 32, lineHeight: 48 },
        SUBLINE: { fontSize: 26, lineHeight: 42 },
        ILLUSTRATION: {
            src: `${IMAGE_ROOT}/home-price.svg`,
            width: 206,
            height: 222,
            top: 1,
            right: 0,
            behindChart: false,
        },
        CHART: { top: 234, left: 30, width: 840, height: 296 },
        DIVIDER_TOP: 546,
    },
    [CHART_TYPE_PRICE_VS_INVENTORY]: {
        BACKGROUND_COLOR: '#F9FFE9',
        BACKGROUND_IMAGE: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 55.58%, #FFFFFF 100%)',
        TEXT_ALIGN: 'center',
        HEADLINE: { fontSize: 32, lineHeight: 42 },
        SUBLINE: { fontSize: 32, lineHeight: 42 },
        ILLUSTRATION: {
            src: `${IMAGE_ROOT}/price-vs-inventory.svg`,
            width: 317,
            height: 94,
            top: 377,
            left: 292,
            behindChart: true,
        },
        CHART: { top: 168, left: 30, width: 840, height: 328 },
        LEGEND_TOP: 512,
        AXIS_TITLES: { left: 'Price', right: 'Inventory' },
        DIVIDER_TOP: 546,
    },
};

export const DEFAULT_SKIN = CHART_TYPE_HOME_PRICE;

export default skins;
